module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-inline-flex py-2 px-3",
    class: {
      'align-self-center': _vm.optionsCount <= 1, 'align-self-end': _vm.optionsCount > 1
    },
    on: {
      "click": _vm.handleClickCaret
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-caret-up': _vm.isShowDropdownList, 'fa-caret-down': !_vm.isShowDropdownList
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-334fc346","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Caret.vue
// module id = 99
// module chunks = 0